class Configuration {
    static APP_URL = 'https://newtaco.pagocash.cl'
}

export default Configuration;